export default __webpack_public_path__ + "static/media/bird.f0e8d6d7.png";